var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClicksIcon = function SvgClicksIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.383 1.241 11.18 6.22l-1.006-.247L11.376.994zM6.37 1.32l-.993.281L6.825 6.54l.993-.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.295 8.284a1.544 1.544 0 0 0-1.47 1.617l.38 7.257c.012.225.074.444.18.643a1.56 1.56 0 0 0 2.1.636l.678-.358 1.987 3.7a1.56 1.56 0 0 0 2.1.636l1.386-.731a1.53 1.53 0 0 0 .64-2.082l-1.988-3.7.678-.359a1.53 1.53 0 0 0 .203-2.589L9.308 8.592a1.56 1.56 0 0 0-1.013-.307m-.436 1.564a.515.515 0 0 1 .49-.539.52.52 0 0 1 .337.102l5.861 4.364a.51.51 0 0 1-.068.863l-1.59.84 2.474 4.606a.51.51 0 0 1-.214.694l-1.385.731a.52.52 0 0 1-.7-.211L10.59 16.69l-1.591.84a.52.52 0 0 1-.76-.426z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.1 10.787-4.634 2.247-.46-.923L5.64 9.864zM17.094 6.54l-.46-.923-4.633 2.247.46.923zM1.595 5.15l-.502.893L5.62 8.57l.501-.893z"
  })));
};
export default SvgClicksIcon;